import React from 'react';
import PropTypes from 'prop-types';
import {
  makeStyles,
  useTheme,
} from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import ShadedRoundBox from 'Components/ComponentLibrary/Atoms/Ornament/ShadedRoundBox';
import List from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/List';
import ListItem from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ListItem';
import ListItemIcon from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ListItemIcon';
import ListItemText from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ListItemText';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

const useStyles = makeStyles(theme => ({
  root: {},
  primaryListItem: {
    fontSize: theme.typography.h5.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.facet.primaryBlue,
  },
  bulletPointIcon: {
    fontSize: theme.typography.h6.fontSize,
  },
  pointsOfInterestBox: {
    padding: theme.spacing(1),
  },
}));

const PointsOfInterestCard = ({
  pointsOfInterest,
}) => {
  const theme = useTheme();
  const classes = useStyles();

  if (pointsOfInterest.length < 1) return null;

  return (
    <ShadedRoundBox
      className={classes.pointsOfInterestBox}
      color={theme.palette.facet.accentBlue20}
    >
      <List
        dense
      >
        {pointsOfInterest.map(poiText => {
          return (
            <ListItem
              key={`${poiText}`}
            >
              <ListItemIcon>
                <FiberManualRecordIcon
                  className={classes.bulletPointIcon}
                  color={'primary'}
                  fontSize={'small'}
                />
              </ListItemIcon>
              <ListItemText
                primary={poiText}
                classes={{
                  primary: classes.primaryListItem,
                }}
              />
            </ListItem>
          );
        })}
      </List>
    </ShadedRoundBox>
  );
};

PointsOfInterestCard.propTypes = {
  pointsOfInterest: PropTypes.array.isRequired,
};

export default PointsOfInterestCard;
